module.exports = __webpack_public_path__ + "static/media/ZPCA.6c4b72a5.pdf";